import {
  APP_STORE_DEVICE_TYPES,
  APP_STORE_LABELS,
  APP_STORES_WITH_BADGE,
  DEVICE_APP_STORES,
} from '../config/appStores';
import type { AppStore, DeviceType } from '../model/types';

export function getDeviceAppStore(deviceType: DeviceType): AppStore {
  return DEVICE_APP_STORES[deviceType];
}

export function getAppStoreDeviceType(store: AppStore): DeviceType {
  return APP_STORE_DEVICE_TYPES[store];
}

export function getDeviceAppStoreLabel(deviceType: DeviceType): string {
  return APP_STORE_LABELS[getDeviceAppStore(deviceType)];
}

export function getVisibleAppStores(deviceType: DeviceType | null): AppStore[] {
  if (deviceType === null) {
    return [...APP_STORES_WITH_BADGE];
  }

  return APP_STORES_WITH_BADGE.filter((store) => store === getDeviceAppStore(deviceType));
}
